export default {
    // title: "仪表数据管理系统",
    currency: {
        no: "序号",
        search: '查询',
        submitText: "确 定",
        clearText: "重置",
        refresh: '刷新',
        cancelText: '取消',
        success: "操作成功!",
        confirmDelete: "确定将选择数据删除?",
        tip: "提示",
        warning: "警告",
        confirm: "确 认",
        cancel: "取 消",
        addSuccess: "新增成功!",
        editSuccess: "修改成功!",
        deleteSuccess: "删除成功!",
        confirmDeletion: "该菜单已被其他角色关联，是否确认删除？",
    },
    estimateRuleMgt: { sheetName: "预估规则管理" },
    logout: {
        logout: "确定注销并退出系统吗？",
        confirm: "确 定",
        successTologOut: "密码修改成功，请重新登录！"
    },
    login: {
        login: "登陆",
        password2: "请输入密码",
        accountLength:"账号长度不超过20位",
        passformat: "密码长度必须是",
        passformatT: "位，且必须包含符号、数字、字母",
        enterUsername: "请输入用户名",
        enterPassword: "请输入密码",
        enterLength: "密码长度最少为6位",
        enterCaptcha: "请输入验证码",
        captchaError: "格式错误",
        userontexist: "用户不存在",
        vercode: "验证码过期或错误",
        userwrong: "用户密码错误",
        passtime: "密码错误过多，请10分钟后在尝试",
        acclock: "账户已锁定，请联系管理员",
        accstop: "账户已被停用，请联系管理员",
        accabnomal: "账户异常，请联系管理员",
        noper: "账户已被删除，请联系管理员",
        frozen: "账户已被冻结，请联系管理员",
        hint: "系统提示",
        register: "重新登录",
        missing: "登录状态已过期，请重新登录！",
        expired: "该账号已在其它地方登录，请重新登录！",
        logging: "登录中,请稍后。。。",
        refersh: "点击刷新",
        logged: "该账户已登录, 是否继续?"
    },
    route: {
        main: "主类目",
        dashboard: "首页",
        AssetManagement: "资产管理",
        MeterArchivesManagement: "电表档案管理",
        MeterReplaceManagement: "仪表更换管理",
        DCUArchivesManagement: "DCU档案管理",
        DCUReplaceManagement: "DCU更换管理",
        OrganizationManagement: "组织管理",
        CustomerManagement: "客户管理",
        SAPManagement: "SAP管理",
        WFMSManagement: "WFMS管理",
        MeterReadingManagement: "抄表管理",
        MeterReadingTemplateSettings: "抄表模板设置",
        MeterReadingTaskRelease: "抄表任务发布",
        MonthlySettlementManagement: "月结管理",
        VEEManagement: "VEE管理",
        VerificationRuleManagement: "验证规则管理",
        EstimateRuleManagement: "估计规则管理",
        MeterDataExceptionMGT: "电表数据异常管理",
        MeterViewDataExceptionManagement: "电表底码数据异常管理",
        MeterProfileDataExceptionManagement: "电表电量数据异常管理",
        DataQuery: "数据查询",
        LoadViewQuery: "负荷底码曲线召测",
        LoadProfileQuery: "负荷电量曲线召测",
        TOUViewQuery: "日冻结底码曲线召测",
        TOUProfileQuery: "日冻结电量曲线召测",
        EOBViewQuery: "月结算底码曲线召测",
        EOBProfileQuery: "月结算电量曲线召测",
        LossManagement: "损失管理",
        LossSummary: "损失总结",
        LossTemplateManangement: "损失模板管理",
        reportquery: "报告查询",
        LossQuery: "损失查询",
        CommandManagement: "命令管理",
        ConnectAndDiconnect: "连接和断开",
        RemoteUpgrade: "远程升级",
        system: "系统管理",
        UserManangement: "账户管理",
        userGroup: "账户组管理",
        DeviceGroupManagement: "设备组管理",
        OrganizationModel: "部门管理",
        MenuManagement: "菜单管理",
        RoleManagement: "角色管理",
        profile: '个人中心',
    },
    navbar: {
        home: '首页',
        product: '产品中心',
        solution: '解决方案',
        shop: '商店',
        customization: '定制',
        community: '社区',
        aboutUs: '关于我们',
        contact: '联系我们',
        lang:'English',
        ioTHardware:'物联网硬件',
        electricEquipment:'电力设备',
        softwarePlatform:'软件与平台',
        discord:'Discord',
        twitter:'Twitter'
    },
     //轮播
     rotation:{
        
    },
    home:{
        title:"电力及物联网解决方案",
        weprovideq:"提供各行业5G无线专网",
        weprovideTow:"整体解决方案",
        titleTow:"专业供应商",
        // viewSolutions:"查看解决方案",
        viewSolutions:"查看方案",
        whatcan:"我们能做什么",
        ourService:"我们的服务",
        ioTHardware:"物联网硬件",
        softwarePlatform:"软件与云平台",
        solution:"行业解决方案",
        focuson:"专注物联网硬件研发，服务电力，农业，气象，环境监测等领域",
        webbased:"基于Web的设备管理和数据展示平台，提供API服务，支持用户进行二次开发",
        providesolutions:"携手合作伙伴，提供电力，气象，环境 监测，畜牧养殖等行业整体解决方案",
        ourAdvantages:"我们的优势",
        whychoose:"优势",
        yearof:"物联网硬件及软件研发年份",
        servingcountries:"服务全球国家",
        globalusers:"服务全球用户数",
        servingFortune:"服务全球500强",
        patents:"获得知识产权专利",
        globalPartners:"全球合作伙伴",
        ourProducts:"推荐产品",
        werecommend:"我们向您推荐这些",

        gateway:"双鱼P100 LoRa室外网关 EU868/US915",
        module:"GPMLx9332-PX V3, LoRa模块, EU868/US915",
        electricMeter:"LoRa 玻璃钢天线，4dBi, EU868/US915",
        electricMeters:"LoraWAN导轨式智能电表",
        abrief:"一款支持Longfi技术的高性能  LoRaWAN产品因此可以处理 Helium网络上的大量数据。",
        abriefTow:"基于数字基带芯片SX1302开发，采用Mini PCIe接口的机械定义，提供SPI接口。",
        abriefThree:"一种高精度高增益且易于安装的  天线，电气绝缘性佳、透波性强，信号较好并且适于各种复杂的环境。",
        abriefFour:"一款遵循LoRaWAN协议的智能电表，并且能连接至Helium网络，具有体积小、高精度、低功耗、稳定性好、安装方便等优点。",
        details:"详情",
        more:"查看更多",
        ourSolutions:"解决方案",
        weprovide:"我们提供全面的行业解决方案",
        viewallSolution:"查看所有方案",
        smartCampus:"智慧园区",
        basedon:"基于物联网技术，实现高效、便捷的集中式管理，降低运营成本。",
        smartStreetLight:"智慧路灯",
        effectivelycontrol:"指通过应用先进通信技术，实现对路灯的远程集中控制与管理。",
        ami:"AMI",
        anautomatic:"AMI是综合现有和新的电力技术的整体架构，包括智能计量、数据采集终端、专变负控终端、交互终端、售电终端、与数据中心的通信网络、以及数据采集管理和数据应用平台。",
        ourPartners:"我们的合作伙伴",
        clickon:"点击图片直接进入网站",

    },
    solution:{
        title:"解决方案",
        all:"全部",
        energy:"能源",
        agricultural:"农业",
        smartCity:"智慧城市",

        ami:"AMI",
        smartStreetLight:"智慧路灯",
        smartCampus:"智慧园区",
        smartAgricultural:"智慧农业",
        aPPbasedPrepaid:"基于APP的预付费",
        basestationEnergySaving:"5G基站节能",
        substationNR:"变电站NR(SA)无线专网",
        wirelessSecurity:"无线安全监控和视频",
        wirelessMetering:"无线仪表计量",
     
        anautomatic:"AMI是综合现有和新的电力技术的整体架构，包括智能计量、数据采集终端、专变负控终端、交互终端、售电终端、与数据中心的通信网络、以及数据采集管理和数据应用平台。",
        animportant:"指通过应用先进通信技术，实现对路灯的远程集 中控制与管理。",
        theentire:"基于物联网技术，实现高效、便捷的集中式 管理，降低运营成本。",
        basedon:"指现代科学技术与农业种植相结合，从而实现 无人化、自动化、智能化管理。",
        userscan:"用户可以使用APP来预付电费、水费、燃气费、房租等费用。",
        significantly:"利用智能化系统，实现设备供电全面保护、智能化告警，降低能耗并极大优化人工 操作流程。",
        reliableandseamless:"进行变电站无线专网覆盖，实现内网在变电站内安全可靠无缝隙的通信全覆盖。",
        throughwireless:"通过无线的传输方式，对重要、敏感地点、设备及周遭情况进行24小时的实时监控。",
        flexiblesystem:"具有系统组网灵活和单点独立组网等特点，实现 “水平隔断、纵向加密”。"
    },
    customization:{
        title:"定制",
        greenPalm:"GreenPalm",
        cutomi:"客户",
        zationService:"定制服务",
        sometimesthe:"很多时候完美的解决方案并不存在，当现有的解决方案不能满足需求时，我们可以为您提供定制服务，创造满足您业务需求的硬件和软件。无论 您已经制定了精确的规范还是需要指导来解决挑战，绿掌都是您将愿景变为现实的合作伙伴。",
        wehavemany:" 我们尤其擅长电力、物联网方面的软件、平台和硬件的开发，在以下领域拥有多年开发经验和多项成功案例:",
        ami:"AMI",
        smartAgricultural:"智慧农业",
        smartStreetLight:"智慧路灯",
        aPPbased:"基于APP的预付费",
        smartCampus:"智慧园区",
        basestation:"5G基站节能",
        hardware:"硬件定制",
        withouradvanced:"我们拥有先进的生产线以及丰富的硬件研发经验，无论您的最终产品的目标是什么，我们都可以为您提供无与伦比的硬件定制。定制内容：",
        boardfunctionality:"板功能",
        memoryUnit:"内存单元",
        sensorActuator:"传感器、执行器和连接器集成",
        schematicDesign:"原理图设计",
        pcbLayout:"PCB布局",
        creatingBOMssourcing:"创建 BOM 和采购",
        expansions:"扩展：Cape, Shield, Hats",

        softwareCutomization:"软件定制",
        ourdevelopers:"我们在软件和平台的设计、开发和运维方面拥有多年经验，已为各行业客户完成许多项目。我们的开发人员熟悉绝大部分的操作系统及编程语言，无论您有什么要求，我们都可以完成您所需要的软件和平台的定制。定制内容：",
        industryType:"行业类别",
        applicationScenarios:"应用场景",
        businessNeeds:"业务需求",
        operatingPlatform:"操作平台",
        userInterface:"用户界面",
        customizationProcess:"定制流程",
        discussion:"讨论",
        solutionProposal:"方案提议",
        development:"开发",
        handOver:"交付",
        afterService:"售后",
        toknow:"明确客户实际的问题以及我们该如何帮助客户。",
        createdconcrete:"基于与客户的讨论提出具体的解决方案。",
        theactual:"开发人员开始实际的软硬件开发，这个过程需要一定时间。",
        afterthe:"在产品开发完成之后，将产品交付给客户让其验收。 ",
        afterhand:"在交付后，我们将根据约定免费或付费提供售后服务。",
        letUsBuild:"让我们来创建您自己的定制",
        writeamessage:"给我们留言",
        yourName:"您的称呼",
        yourEmail:"您的邮箱",
        yourPhone:"您的手机",
        message:"留言内容",
        submit:"提交",
        contactinformation:"联系信息",
        ourEmail:"邮箱",
        trade:"trade01@greenpalm.cn",
        ourAddress:"地址",
        // room:"浙江省杭州市萧山区北干街道启迪路198号 杭州湾信息港C座412",
        room:"浙江省杭州市萧山区新街街道建设四路4368号1幢2层",

    },
    about:{
        title:"关于我们",
        aboutUs:"关于我们",
        pofessionalprovider:"电力及物联网解决方案专业供应商",
        hangzhouGreenPalmo:"杭州绿掌科技有限公司成立于2012年，专业从事用电信息采集平台、硬件，物联网解决方案及设备的研发和生产", 
        wehavemore:"公司拥有研发、技术人员四十多人，成立有若干个以产品系列为主线的研发团队，由从事多年研发工作经验的智能电网行业专家担任项目组长，分工明确，责任到人。公司研发团队具备完全自主创新的研发能力，对主导产品掌握并拥有产品的关键技术。优秀的研发能力，良好的服务能力得到了广大合作伙伴的认可。",
        greenPalmis:"绿掌科技致力于基于物联网&互联网技术的绿色能源颠覆性创新、绿色节能创新及综合能源站建设。公司致力于开拓国际市场，产品遍布五大洲40余个国家。公司坚持以引领物联网绿色能源技术的发展为导向，以人才和技术创新为动力，不断为业界提供优秀的能源物联网解决方案，努力成为行业的国际领军企业。",
        ioTHardware:"物联网硬件",
        softwarePlatform:"软件与云平台",
        solution:"行业解决方案",

        globalLayout:"全球布局",
        servingcountries:"服务全球国家",
        globalusers :"服务全球用户数",
        servingFortune:"服务全球500强",
        globalbranch:"全球分部",
        globalpartners :"全球合作伙伴",

        branchs:"分支机构",
        hangzhouGreenPalm:"杭州绿掌",
        jiangsuGreenPalm :"江苏绿掌",
        middleeast:"中东研发中心",
        southAmericanR:"南美研发中心",
        singaporeGreenPalm:"新加坡公司",
        northAmerican:"北美服务中心",

       

        productionEnvironment:"生产环境",
        ourMajor:"主要客户及合作伙伴",
        certification:"认证及资质",

    },
    contact:{
        title:"联系我们",
        letUsBuild:"让我们来创建您自己的定制",
        writeamessage:"给我们留言",
        yourName:"您的称呼",
        yourEmail:"您的邮箱",
        yourPhone:"您的手机",
        message:"留言内容",
        submit:"提交",
        contactinformation:"联系信息",
        ourEmail:"邮箱",
        trade:"trade01@greenpalm.cn",
        ourAddress:"地址",
        // room:"浙江省杭州市萧山区北干街道启迪路198号 杭州湾信息港C座412",
        room:"浙江省杭州市萧山区新街街道建设四路4368号1幢2层",

    },
    bottom:{
        hangzhouGreenPalm:"杭州绿掌科技有限公司",
        community:"社区:",
        navigation:"导航",
        home:"首页",
        solution:"解决方案",
        shop:"商店",
        customization:"定制",
        aboutUs:"关于我们",
        contactUs:"联系我们",
        // room:"浙江省杭州市萧山区北干街道启迪路198 号杭州湾信息港C座412",
        room:"浙江省杭州市萧山区新街街道建设四路4368号1幢2层",
        trade:"trade01@greenpalm.cn",
        copyright:"© 版权所有 杭州绿掌科技有限公司 | 浙ICP备18035527号-2",
    },
    message:{
        userName:"请输入您的称呼",
        userEmail:"请输入邮箱地址",
        correctUserEmail:"请输入正确的邮箱地址",
        userPhone:"请输入您的手机号(包含区号)",
        userMessage:"请输入您的留言",
        successfully:"发送成功"
    }
}


// WEBPACK FOOTER //
// ./src/lang/zh/base.js